function view_events_of(object, id) {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/events/view_of/'+object+'/'+id,
        onOpen: function (elm, popup) {
        }
    });
    return false;
}